export default __webpack_public_path__ + "static/taskdefinition6-8e38426d087e629760e8de6693f68506.png";